import {
  PivotValueFilterDirectionEnum,
  PivotValueFilterModeEnum,
  PivotValueFilterScopeEnum,
} from '@ztechapps/common.contract'
import type { PivotLayout, PivotLayoutFilter } from '@ztechapps/common.contract'

/** One pivot value filter in the chip and card voice, e.g. `city Top 10% · net (Sum) · within country`. */
export const describePivotValueFilter = (
  layout: Pick<PivotLayout, 'rows' | 'columns'>,
  filter: PivotLayoutFilter
): string => {
  const { valueFilter } = filter
  if (valueFilter === undefined) return filter.field
  const { measure, direction, mode, value, scope } = valueFilter
  const directionText = direction === PivotValueFilterDirectionEnum.top ? 'Top' : 'Bottom'
  const countText = `${value}${mode === PivotValueFilterModeEnum.percent ? '%' : ''}`
  const text = `${filter.field} ${directionText} ${countText} · ${measure.field} (${measure.aggregation})`
  if (scope !== PivotValueFilterScopeEnum.perParent) return text
  // the parent is the previous field of the axis the ranked field sits on
  const isSameItem = (item: { field: string; dateGroup?: unknown }): boolean =>
    item.field === filter.field && item.dateGroup === filter.dateGroup
  const axis = layout.rows.some(isSameItem) ? layout.rows : layout.columns
  const parent = axis[axis.findIndex(isSameItem) - 1]
  return parent ? `${text} · within ${parent.field}` : text
}
